<template>

    <!-- 内容区域 -->
  <div class="document-container">
    <!-- 进度条和提示信息区域 - 上下排列 -->
    <div class="header-section">
      <AdminProgressbar v-if="userType=='admin'" :current-step="3" :tenantId="tenantId"/>
      <EmployeeProgressbar :currentStep="1" :tenantId="tenantId" :username="userInfo.userName"/>      
      <div class="dashboard-tab">
              <h3 class="tab-title">知识库文档管理</h3>
        <div class="tips-container">
          <img src="@/assets/images/agent02.png" class="agent-img" alt="AI客服专员"/>
          <a class="info-text">尊敬的<b>{{ this.versionName}}</b>用户,您上传的知识库文档数量：{{doc_count_tenant}}/{{ maxFileCount }}；您使用的知识库空间：{{doc_storage_space}}{{doc_storage_space_unit}}/{{ this.maxStorageSpace }}MB。</a>  
          <a href="/admin/knowledge" class="link">返回知识库管理页面</a>      
        </div>

      </div>
    </div>
    <!-- 左右容器区域 -->
    <div class="main-content">    
      <div class='left-container'>
  <p class="container-title"><b>全局文档库</b>：独立于知识库，其中的文档可以用于训练您任意知识库的AI客服。</p>
  
  <!-- 搜索和操作工具栏 -->
  <div class="toolbar">
    <div class="toolbar-left">
      <el-select v-model="docType" size="mini" style="width:100px; margin-right:10px;" @change="handleSelectDocType">
             <el-option label="全部文档类型" value="0">全部文档类型1</el-option>             
          <el-option label="图文文档" value="3">图文文档</el-option>    
                  <el-option label="问答对文档" value="4">问答对文档</el-option>  
      </el-select>    
      <el-select v-model="dirId" size="mini" style="width:100px; margin-right:10px;" @change="handleSelectDir">
        <el-option v-for="dir in dirs" :key="dir.id" :label="dir.name" :value="dir.id"></el-option>
      </el-select>
      
      <el-input 
        type="text" 
        v-model="keyword_doclibrary" 
        placeholder="搜索关键字" 
        size="mini"
        style="width: 200px; margin-right: 10px;"
        @keyup.enter.native="HandleLoadDocTable" />
      
      <el-button type="primary" size="mini" icon="el-icon-search" @click="HandleLoadDocTable">搜索</el-button>
    </div>
    
    <div class="toolbar-right">
      <el-button 
        type="text"  
        v-if="kbworkspaceFolder" 
        size="mini" 
        icon="el-icon-folder-opened" 
        @click="HandleDirManage">
        目录管理
      </el-button>
      
      <!-- el-button 
        v-if="doc_count_tenant < this.maxFileCount" 
        type="text" 
        size="mini"  
        @click.native="HandleUploadDocument" 
        icon="el-icon-upload2">
        上传文件
      </el-button -->
      
      <!--el-button  
        v-if="doc_count_tenant < this.maxFileCount && doc_storage_space_mb<maxStorageSpace"  
        type="text" 
        size="mini" 
        @click="HandleUploadLink"
        class="btn-with-icon">
        <svg t="1762249362795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2097" width="12" height="12">
          <path d="M810.07 64.56H220c-83.81 0-152 68.19-152 152v590.07c0 83.81 68.19 152 152 152h590.07c83.81 0 152-68.19 152-152V216.56c0-83.81-68.19-152-152-152z m-590.07 64h590.07c48.52 0 88 39.48 88 88v69.77H132v-69.77c0-48.52 39.48-88 88-88z m590.07 766.07H220c-48.52 0-88-39.48-88-88v-456.3h766.07v456.3c0 48.52-39.48 88-88 88z" fill="#1296db" p-id="2098"></path>
          <path d="M226.65 255.8h95.19c17.67 0 32-14.33 32-32s-14.33-32-32-32h-95.19c-17.67 0-32 14.33-32 32s14.33 32 32 32zM768.03 479.15H256.42c-17.67 0-32 14.33-32 32s14.33 32 32 32h511.61c17.67 0 32-14.33 32-32s-14.33-32-32-32zM577.89 670.91H256.42c-17.67 0-32 14.33-32 32s14.33 32 32 32h321.47c17.67 0 32-14.33 32-32s-14.33-32-32-32z" fill="#1296db" p-id="2099"></path>
        </svg>
        抓取网页
      </el-button-->
 <el-button  
        v-if="doc_count_tenant < this.maxFileCount && doc_storage_space_mb<maxStorageSpace"  
        type="text" 
        size="mini" 
        @click="handleQAeditor"
        class="btn-with-icon">
        <svg t="1784507066519" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5612" width="16" height="16"><path d="M512 938.666667c235.648 0 426.666667-191.018667 426.666667-426.666667S747.648 85.333333 512 85.333333 85.333333 276.352 85.333333 512s191.018667 426.666667 426.666667 426.666667z m0 85.333333C229.248 1024 0 794.752 0 512S229.248 0 512 0s512 229.248 512 512-229.248 512-512 512z" fill="#1296db" p-id="5613"></path><path d="M520.96 232.106667c-62.293333 0-111.786667 17.92-147.626667 54.613333-36.693333 35.84-54.613333 84.48-54.613333 146.773333h90.453333c0-37.546667 7.68-67.413333 23.04-87.893333 17.066667-23.893333 45.226667-35.84 83.626667-35.84 30.72 0 54.613333 8.533333 71.68 25.6 16.213333 17.066667 24.746667 40.106667 24.746667 69.973333 0 22.186667-7.68 42.666667-23.04 62.293334l-14.506667 16.213333c-52.906667 46.933333-85.333333 81.92-97.28 105.813333-11.093333 22.186667-16.213333 49.493333-16.213333 81.066667v14.506667h91.306666v-14.506667c0-21.333333 4.266667-40.106667 13.653334-57.173333 7.68-15.36 19.626667-29.866667 34.986666-43.52 40.96-34.986667 64.853333-57.173333 72.533334-66.56 20.48-27.306667 31.573333-62.293333 31.573333-104.106667 0-51.2-17.066667-92.16-50.346667-122.026667-34.133333-30.72-78.506667-45.226667-133.973333-45.226666z m-14.506667 499.2c-17.92 0-32.426667 5.12-43.52 17.066666-12.8 11.093333-18.773333 25.6-18.773333 43.52 0 17.066667 5.973333 31.573333 18.773333 43.52 11.093333 11.946667 25.6 17.92 43.52 17.92 17.066667 0 32.426667-5.973333 45.226667-17.066666 11.946667-11.946667 17.92-26.453333 17.92-44.373334 0-17.92-5.973333-32.426667-17.92-43.52-11.946667-11.946667-27.306667-17.066667-45.226667-17.066666z" fill="#1296db" p-id="5614"></path></svg>
        问答对编辑器
      </el-button>      
      
      <el-button  
        v-if="doc_count_tenant < this.maxFileCount && doc_storage_space_mb<maxStorageSpace"  
        type="text" 
        size="mini" 
        @click="HandleCreateEditorDoc"
        class="btn-with-icon">
        <svg t="1767705505074" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5753" width="16" height="16">
          <path d="M853.333333 213.333333a42.666667 42.666667 0 0 0-42.666666-42.666666h-597.333334a42.666667 42.666667 0 0 0-42.666666 42.666666v341.333334a42.666667 42.666667 0 0 0 42.666666 42.666666h597.333334a42.666667 42.666667 0 0 0 42.666666-42.666666v-341.333334m85.333334 0v341.333334a128 128 0 0 1-128 128h-597.333334a128 128 0 0 1-128-128v-341.333334a128 128 0 0 1 128-128h597.333334a128 128 0 0 1 128 128z" fill="#1296db" p-id="5754"></path>
          <path d="M725.333333 725.333333m0 42.666667l0 0q0 42.666667-42.666666 42.666667l-341.333334 0q-42.666667 0-42.666666-42.666667l0 0q0-42.666667 42.666666-42.666667l341.333334 0q42.666667 0 42.666666 42.666667Z" fill="#1296db" p-id="5755"></path>
          <path d="M810.666667 853.333333m0 42.666667l0 0q0 42.666667-42.666667 42.666667l-512 0q-42.666667 0-42.666667-42.666667l0 0q0-42.666667 42.666667-42.666667l512 0q42.666667 0 42.666667 42.666667Z" fill="#1296db" p-id="5756"></path>
          <path d="M384 384m-64 0l0 0q-64 0-64-64l0 0q0-64 64-64l0 0q64 0 64 64l0 0q0 64-64 64Z" fill="#1296db" p-id="5757"></path>
          <path d="M868.437333 648.789333a42.666667 42.666667 0 0 1-42.026666-35.626666 738.133333 738.133333 0 0 0-32.042667-118.485334c-26.325333-70.485333-53.504-95.445333-68.821333-95.445333-26.752 0.384-40.874667 18.986667-66.688 61.354667-23.125333 37.973333-54.698667 89.6-117.418667 89.6h-2.005333a173.738667 173.738667 0 0 1-109.098667-38.954667c-15.36-11.093333-21.888-15.36-33.237333-15.36h-4.266667c-1.621333 0-25.898667 2.602667-99.797333 67.114667-41.002667 35.797333-75.221333 71.722667-75.562667 72.064a42.666667 42.666667 0 0 1-61.909333-58.709334c1.493333-1.578667 36.906667-38.826667 80.853333-77.226666 86.528-75.648 127.104-86.656 150.186667-88.362667 3.456-0.256 6.826667-0.384 10.112-0.384a133.845333 133.845333 0 0 1 83.413333 31.488 91.178667 91.178667 0 0 0 60.672 22.826667h0.298667c13.482667 0 24.576-15.701333 44.757333-48.853334 26.026667-42.666667 61.653333-101.248 138.410667-102.4h1.536c61.397333 0 111.530667 51.2 149.034666 152.021334a820.224 820.224 0 0 1 35.84 133.077333 42.666667 42.666667 0 0 1-42.112 49.749333z" fill="#1296db" p-id="5758"></path>
        </svg>
        新建图文文档
      </el-button>
    </div>
  </div>
  <!-- 表格区域 -->
    <div class="table-wrapper">
      <el-table
        :data="docList"
        style="width: 100%;"
        class="custom-table"
        header-row-class-name="custom-header"
        row-class-name="custom-row"
        v-loading="loading">

        <el-table-column prop="title" label="标题" width="150" align="center"></el-table-column>
        <el-table-column prop="docType" label="类型" width="80" align="center">
          <template slot-scope="scope">

            <svg v-if="scope.row.doc_type==1" t="1762931655444" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5542" width="16" height="16">
              <path d="M896.17 98.23H662.26c-34.96 37.22-89.44 61.16-150.65 61.16s-115.7-23.94-150.66-61.16H128.03v828.41h231.23c55.25 0 148.5 0.2 148.5 0.2s103.25-0.2 156.21-0.2h232.21V98.23h-0.01zM511.61 223.39c66.2 0 128.75-22.01 175.84-61.16h144.72v700.41H663.96c-51.81 0-152.91 0.2-156.26 0.2-4.74-0.01-94.94-0.2-148.45-0.2H192.03V162.23h143.74c47.09 39.15 109.64 61.16 175.84 61.16z" fill="#1296db" p-id="5543"></path>
              <path d="M449 255.95H255.95V320H449v-64.05zM766.21 741.2h-190.1v64.05h190.1V741.2zM576.11 377.27H255.95v64.04h320.16v-64.04zM767.99 377.27H638.64v64.04h129.35v-64.04zM768.15 498.58h-512.2v64.04h512.2v-64.04zM768.15 619.89h-512.2v64.04h512.2v-64.04z" fill="#1296db" p-id="5544"></path>
            </svg>
            &nbsp;<a v-if="scope.row.doc_type==1">文件</a>
            <svg  v-if="scope.row.doc_type==2" style t="1762920171159" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6643" width="16" height="16">
              <path d="M512 64C264.58 64 64 264.58 64 512s200.58 448 448 448 448-200.58 448-448S759.42 64 512 64z m-32 254.28c-42.98-3.6-83.97-14.09-121.75-30.77 30.6-80.53 75.81-135.21 121.75-153.02v183.79z m0 64.01V480H320.89c2.05-47.45 8.52-91.44 18.39-131.18 43.79 18.45 91.1 29.93 140.72 33.47zM480 544v97.71c-49.62 3.54-96.93 15.02-140.72 33.47-9.88-39.74-16.34-83.73-18.39-131.18H480z m0 161.72v183.79c-45.94-17.81-91.15-72.5-121.75-153.02 37.78-16.69 78.77-27.18 121.75-30.77z m64 0c42.98 3.6 83.97 14.09 121.75 30.77-30.6 80.53-75.81 135.22-121.75 153.02V705.72z m0-64.01V544h159.11c-2.05 47.45-8.51 91.44-18.39 131.18-43.79-18.46-91.1-29.93-140.72-33.47zM544 480v-97.71c49.62-3.54 96.93-15.02 140.72-33.47 9.88 39.74 16.34 83.73 18.39 131.18H544z m0-161.72V134.49c45.94 17.8 91.15 72.5 121.75 153.02-37.78 16.69-78.77 27.18-121.75 30.77z m128.96-154.45a384.634 384.634 0 0 1 92.13 60.11c-13.46 11.87-27.99 22.48-43.01 32.4-13.84-34.73-30.36-65.9-49.12-92.51z m-371.03 92.52c-15.02-9.93-29.55-20.53-43.01-32.4a384.332 384.332 0 0 1 92.13-60.11c-18.77 26.6-35.29 57.77-49.12 92.51z m-20.74 62.85c-13.48 49.33-21.94 103.51-24.26 160.8h-127.3c6.58-79.23 37.12-151.72 84.62-210.04 20.64 18.46 43.14 34.81 66.94 49.24zM256.92 544c2.32 57.29 10.78 111.47 24.26 160.8-23.8 14.43-46.29 30.78-66.95 49.24-47.5-58.32-78.04-130.81-84.62-210.04h127.31z m45.01 223.65c13.83 34.74 30.35 65.92 49.12 92.52a384.634 384.634 0 0 1-92.13-60.11c13.46-11.88 27.99-22.49 43.01-32.41z m420.14 0c15.02 9.93 29.55 20.53 43.01 32.4a384.332 384.332 0 0 1-92.13 60.11c18.77-26.6 35.29-57.77 49.12-92.51z m20.74-62.85c13.48-49.33 21.94-103.51 24.26-160.8h127.3c-6.58 79.23-37.12 151.72-84.62 210.04-20.64-18.46-43.14-34.81-66.94-49.24zM767.08 480c-2.32-57.29-10.78-111.47-24.26-160.8 23.8-14.43 46.29-30.78 66.95-49.24 47.5 58.32 78.04 130.81 84.62 210.04H767.08z" fill="#1296db" p-id="6644"></path>
            </svg>
            &nbsp;<a v-if="scope.row.doc_type==2">网址</a>
            <a v-if="scope.row.doc_type==3">图文文档</a>                        
                        <a v-if="scope.row.doc_type==4">问答对</a>     
          </template>
        </el-table-column>        
        <el-table-column label="状态" prop="status" :show-overflow-tooltip="true" width="100">
          <template slot-scope="scope">
            <el-tag  type="info" effect="light"  v-if="scope.row.status === 0" size="small">
              <i class="el-icon-warning"></i>-不在文档库中-
            </el-tag>
            <el-tag v-else-if="scope.row.status === 1" type="warning" effect="light" size="small">
              <i class="el-icon-upload2"></i> 已上传，待处理
            </el-tag>
            <el-tag v-else-if="scope.row.status === 2" type="primary" effect="light" size="small">
              <i class="el-icon-loading"></i> 处理中
            </el-tag>
            <el-tag v-else-if="scope.row.status === 3" type="success" effect="light" size="small">
              <i class="el-icon-check"></i> 已训练AI客服
            </el-tag>
            <el-tag v-else-if="scope.row.status === 4" type="warning" effect="light" size="small">
              <i class="el-icon-delete"></i> 已从知识库中移除
            </el-tag>    
            <el-tag v-else type="info" effect="light" size="small">
              <i class="el-icon-question"></i> 未知状态
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="action" label="操作" align="center">
          <template #default="scope">
            <el-button @click="HandleDocDetail(scope.row)" size="mini" type="text" icon="el-icon-search">
              详情
            </el-button>
            
            <!-- 新增编辑按钮 -->
            <el-button @click="HandleEditDocument(scope.row)" size="mini" type="text" icon="el-icon-edit">
               编辑
            </el-button>
            
            
            <el-button @click="HandleRemove(scope.row)" size="mini" type="text" icon="el-icon-remove">
              删除
            </el-button>
            <el-button @click="HandleEmbedding(scope.row)" v-if="!scope.row.isInWorkspace && scope.row.doc_type===3" size="mini" type="text">
              <svg t="1763763370034" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5577" width="12" height="12">
                <path d="M853.206326 411.052651a402.455814 402.455814 0 0 0-48.104186-21.646884V234.924651c-82.586791 33.815814-204.490419 55.724651-352.708466 55.724651-148.289488 0-268.359442-21.908837-350.87479-55.724651v142.645582c-7.382326 0-1.26214 4.024558 18.479628 11.906976 26.957395 10.906791 147.408372 62.916465 298.484093 52.152558a379.975442 379.975442 0 0 0-85.920745 87.39721c-93.993674-7.382326-172.174884-23.766326-230.971534-47.889861v135.239442c-1.690791 9.001674 4.429395 16.907907 18.336744 23.766326 13.07386 6.429767 72.013395 20.622884 152.933209 30.862883a349.588837 349.588837 0 0 0-4.357953 88.206884c-65.917023-7.096558-121.927442-18.860651-166.983442-37.292651v127.261767c0.523907 11.573581 6.667907 20.051349 18.479628 25.6 28.957767 14.931349 103.281116 38.102326 204.657116 49.533024A379.737302 379.737302 0 0 0 419.435163 1024C196.298419 1019.094326 16.979349 964.608 0 896.357209L1.619349 128C19.360744 56.32 214.182698 0 452.322233 0 690.509395 0 885.259907 56.462884 904.930233 128v315.987349a392.025302 392.025302 0 0 0-1.333582-1.024 137.978047 137.978047 0 0 0-7.310884-6.596465 187.725395 187.725395 0 0 0-43.079441-25.242791v-0.071442zM462.466977 166.697674C654.169302 166.697674 809.674419 105.495814 809.674419 95.851163 809.674419 86.206512 654.264558 47.627907 462.466977 47.627907 270.764651 47.627907 119.069767 86.206512 119.069767 95.851163 119.069767 105.495814 270.693209 166.697674 462.466977 166.697674z m506.951442 639.190326a117.64093 117.64093 0 0 1-82.15814 8.596837 104.68614 104.68614 0 0 1-46.294326-26.195349l-206.919441 67.155349c0 9.382698-0.666791 14.907535-2.786233 21.837396-8.120558 26.600186-27.624186 49.03293-54.057674 62.202046a125.83293 125.83293 0 0 1-82.467721 10.24c-31.458233-6.548837-58.534698-24.790326-74.775814-50.390326-30.886698-48.699535-12.954791-111.163535 40.102697-139.549767l2.952931-1.524093c6.786977-3.453023 12.835721-5.405767 22.718511-7.620465l30.815256-236.66307a99.851907 99.851907 0 0 1-42.293581-35.95907c-28.981581-45.722791-12.145116-104.400372 37.673674-131.024372l2.738605-1.405023c52.200186-25.909581 117.402791-9.239814 147.479814 37.721302 14.336 22.742326 17.979535 49.056744 10.335256 74.037582a30.219907 30.219907 0 0 1-3.381582 7.334697l199.965768 168.126512c23.242419-9.858977 49.294884-11.668837 75.347348-5.429581 27.790884 7.072744 51.057116 23.575814 65.393117 46.246697 28.981581 45.651349 12.145116 104.20986-37.578419 130.810047a107.162791 107.162791 0 0 1-2.810046 1.452651zM543.50586 497.473488c13.407256 4.286512 27.933767 3.333953 40.721861-2.667162h0.309581l4.596093-2.500466c27.862326-15.36 38.173767-50.771349 23.099535-79.086139a59.892093 59.892093 0 0 0-82.134325-24.623628c-27.909953 15.502884-38.197581 51.104744-22.956652 79.490977l0.738233 1.357395a60.249302 60.249302 0 0 0 35.625674 28.029023z m-2.024186 399.931535c27.814698-15.336186 38.197581-50.795163 23.147163-79.205209a59.868279 59.868279 0 0 0-39.531163-30.72 59.058605 59.058605 0 0 0-42.65079 5.953488c-27.862326 15.526698-38.149953 51.176186-22.956651 79.610047a59.915907 59.915907 0 0 0 81.967627 24.361674zM901.834419 783.955349c14.978977 3.810233 30.791442 1.833674 44.413023-5.524837 27.838512-15.336186 38.245209-50.795163 23.242418-79.20521a60.320744 60.320744 0 0 0-39.674046-30.839069 59.034791 59.034791 0 0 0-42.531721 5.953488c-27.862326 15.47907-38.173767 51.08093-23.028093 79.538605l0.809674 1.428837c7.906233 13.835907 20.765767 24.004465 35.863814 28.338604l0.904931 0.23814v0.071442zM621.949023 500.093023c-7.120372 3.667349-31.077209 7.263256-38.840558 9.09693l-28.052837 242.187907c17.789023 7.620465 55.367442 27.147907 66.917209 42.674605L807.293023 726.563721c-0.142884-14.121674-3.19107-36.340093 2.357582-49.27107L621.949023 500.093023z" fill="#1296db" p-id="5578"></path>
              </svg>
              嵌入知识库
            </el-button>

            <el-button @click="HandleDownload(scope.row)" v-if="scope.row.docType==1" size="mini" type="text" icon="el-icon-download">
              应急下载
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <div class="pagination-wrapper" >
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
  <!-- 右边的表格容器 -->
  <div class="right-container">
    <p class="container-title"><b>知识库</b>【{{workspaceName}}】-文档管理</p>
    
    <!-- 右边表格的工具栏 -->
    <div class="toolbar toolbar-right-only">
      <el-select v-model="doc_type_workspace" size="mini" style="width:120px; margin-right:10px;" @change="handleSelectDocTypeWorkspace">
        <el-option label="全部文档" value="0"></el-option>
        <el-option label="文档库文档" value="1">文档库文档</el-option>          
        <el-option label="非文档库文档" value=2>非文档库文档</el-option>           
      </el-select>
      
      <el-input 
        type="text" 
        v-model="keyword_workspace" 
        placeholder="搜索关键字" 
        size="mini"
        style="width: 200px; margin-right: 10px;"
        @keyup.enter.native="HandleLoadWorkspaceDocTable" />
      
      <el-button type="primary" size="mini" icon="el-icon-search" @click="HandleLoadWorkspaceDocTable">搜索</el-button>
    </div>
    
    <!-- 右边表格区域 -->
    <div class="table-wrapper">
      <el-table
        :data="workspace_docList"
        style="width: 100%;"
        class="custom-table"
        header-row-class-name="custom-header"
        row-class-name="custom-row"
        v-loading="loading">

        <el-table-column prop="title" label="标题" width="150" align="center">
          <template slot-scope="scope">
            <svg v-if="scope.row.title=='-不在文档库中-'" t="1763694775378" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5554" width="16" height="16">
              <path d="M1001.661867 796.544c48.896 84.906667 7.68 157.013333-87.552 157.013333H110.781867c-97.834667 0-139.050667-69.504-90.112-157.013333l401.664-666.88c48.896-87.552 128.725333-87.552 177.664 0l401.664 666.88zM479.165867 296.533333v341.333334a32 32 0 1 0 64 0v-341.333334a32 32 0 1 0-64 0z m0 469.333334v42.666666a32 32 0 1 0 64 0v-42.666666a32 32 0 1 0-64 0z" fill="#FAAD14" p-id="5555"></path>
            </svg>
            <svg  v-if="scope.row.title !=='-不在文档库中-'" t="1768998288050" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5541" width="16" height="16"><path d="M512 512m-448 0a448 448 0 1 0 896 0 448 448 0 1 0-896 0Z" fill="#4CAF50" p-id="5542"></path><path d="M738.133333 311.466667L448 601.6l-119.466667-119.466667-59.733333 59.733334 179.2 179.2 349.866667-349.866667z" fill="#CCFF90" p-id="5543"></path></svg>
            <a>{{ scope.row.title }}</a>
          </template>
        </el-table-column>     
        <el-table-column label="唯一标识" prop="docId" :show-overflow-tooltip="true" width="180"></el-table-column>

        <el-table-column label="嵌入日期" prop="createdAt" width="100">
          <template slot-scope="scope">
            {{ scope.row.lastUpdatedAt[0] }}-{{ scope.row.lastUpdatedAt[1] }}-{{ scope.row.lastUpdatedAt[2] }}
          </template>
        </el-table-column>
        <el-table-column prop="action" label="操作" align="center">
          <template #default="scope">
            <el-button v-if="scope.row.title!=='-不在文档库中-'"  @click="HandleDocDetail(scope.row)" size="mini" type="text" icon="el-icon-search">
              详情
            </el-button>         
            <el-button @click="HandleRemoveFromWorkspace(scope.row)" size="mini" type="text" icon="el-icon-remove">
              移除
            </el-button>

            <el-button @click="HandleDownload(scope.row)" v-if="scope.row.docType==1" size="mini" type="text" icon="el-icon-download">
              应急下载
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</div>    
      <!-- 文档目录管理对话框 -->
      <el-dialog
        :visible.sync="open_dir_manage"
        title="文档目录管理"
        width="100"
        append-to-body
      >
        <AnythingllmDirManage v-if="open_dir_manage" :tenantId="tenantId"  />
    </el-dialog>

    <!--上传文档对话框 -->
    <el-dialog
        :visible.sync="open_upload"
        title="上传文档"
        width="80%"
        height="200px"
        append-to-body
      >
        <AnythingllmUploadDocument
        v-if="open_upload"
        :targetDir="form_dir.dir"
        :workspace_slug="workspaceSlug"
        :workspace_name="workspaceName"
        :tenantId="tenantId"
        :username="userInfo.userName"
        :dirId="dirId"
        @submit-success="HandleUploaddocSucess"
        ref="uploadComponent" />
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm_upload">确 定</el-button>
          <el-button type="plain" @click="cancel_upload">取 消</el-button>
        </div>
    </el-dialog>
    <!-- 文件文档详情对话框 -->
     <el-dialog
        :visible.sync="open_details"
        title="文档详情"
        width="600"
        append-to-body
      >
      <el-form :model="form_details" ref="form_details">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="文档名称" prop="title">
               <span>{{ form_details.title }}</span>
          </el-form-item>
          </el-col>
                    <el-col :span="12">
            <el-form-item label="文档类型" prop="title">
               <span v-if="form_details.docType==1">文件</span>
               <span v-if="form_details.docType==2">在线网页</span>
               <span v-if="form_details.docType==3">图文文档</span>               
         <span v-if="form_details.docType==4">问答对文档</span>                   
          </el-form-item>
          </el-col>
          </el-row>
          <el-row :gutter="20">          
            <el-col :span="12">
           <el-form-item v-if="form_details.createdAt!=undefined" label="上传时间" prop="createdAt">
            <span>{{ form_details.createdAt[0] }}-{{ form_details.createdAt[1] }}-{{ form_details.createdAt[2]}} 
              {{ form_details.createdAt[3] }}:{{ form_details.createdAt[4] }}:0
            </span>
           </el-form-item>
            </el-col>
            <el-col :span="12">
           <el-form-item v-if="form_details.updatedAt!=undefined" label="最近更新时间" prop="lastUpdatedAt">
            <span>{{ form_details.updatedAt[0] }}-{{ form_details.updatedAt[1] }}-{{ form_details.updatedAt[2]}} {{form_details.updatedAt[3]}}:{{form_details.updatedAt[4]}}:{{ form_details.updatedAt[5] }} </span>
           </el-form-item>
            </el-col>            
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="所在目录" prop="dir">
              <span>{{ form_details.dir }}</span>
            </el-form-item>

          </el-col>

          <el-col :span="12">
            <el-form-item label="文件大小" prop="size" v-if="form_details.docType==1">
              <span v-if="form_details.size>1024*1024">{{ (form_details.size/1024/1024).toFixed(2) }}MB</span>
              <span v-if="form_details.size>1024 && form_details.size<1024*1024">{{ (form_details.size/1024).toFixed(2) }}KB</span>
              <span v-if="form_details.size<1024">{{ form_details.size }}B</span>
            </el-form-item>
       <el-form-item label="图片数-字数" prop="size" v-if="form_details.docType==3">
              <span>{{ form_details.imageCount }}图-{{form_details.wordCount  }}字</span>

            </el-form-item>            
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item v-if="form_details.docType==2" label="URL" prop="url">
              <a :href="form_details.url" target="_blank">{{ form_details.url }}</a>
          </el-form-item>
        </el-col>
      </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="状态" prop="status">
              <span>{{ form_details.status }}</span>
          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="已嵌入知识库" prop="workspace">
              <span>{{ form_details.workspace }}</span>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>

      </el-dialog>

    <!-- 应急下载对话框 -->
    <el-dialog
        :visible.sync="open_download"
        title="应急下载"
        width="500"
        append-to-body
      >
      <DocumentDowload v-if="open_download" :doc_id="doc_id" :tenantId="tenantId"  @submit-success="closeDownloadDialog" />

      </el-dialog>
  <!-- 编辑对话框 -->    
 <!--抓取网页对话框 -->
    <el-dialog
        :visible.sync="open_upload_link"
        title="抓取网页"
        width="500"
        append-to-body
      >
        <AnythingllmUploadLink
        v-if="open_upload_link"
        :tenantId="tenantId"
        :folder_name="form_dir.dir"
        :dirs="dirs"
        :workspace_name="workspaceName"
        :workspace_slug="workspaceSlug"
        :username="userName"
        @submit-success="UploadLinkSucces"
        ref="uploadComponent" />
        <div slot="footer" class="dialog-footer">
            <el-button type="primary"  @click="submitForm_upload_link">
                <span v-if="!loading_uploadlink">确 定</span>
                <span v-else>
                      <i class="el-icon-loading"></i> 处理中...
                    </span>
              </el-button>
          <el-button type="plain" @click="cancel_upload_link">取 消</el-button>
        </div>
      </el-dialog>  
  <!-- 新建/编辑图文文档对话框 -->
      <el-dialog
        title=" 图文编辑器"
        :visible.sync="open_editor"
        width="95%"
        top="2vh"
        append-to-body
        :close-on-click-modal="false"
        custom-class="editor-dialog"
      >
        <AnythingllmRichEditor
          v-if="open_editor"
          ref="editorComponent"
          :edit-data="currentEditDoc"
          :default-dir-id="defaultDirId"
          :userName="userName"
          :tenantId = "tenantId"
          :dir-list="editorDirList"
          :workspaceSlug="workspaceSlug"          
          @content-change="onEditorContentChange"
          @dir-change="onEditorDirChange"
        />
      </el-dialog>          

  <!-- 编辑对话框 -->
    <el-dialog 
      v-model="editDialogVisible" 
      title="编辑文档" 
      width="80%"
      @opened="onEditDialogOpened" 
    >

    </el-dialog>   
    
  <!-- 全局文档库：问答对编辑器对话框 -->
    <el-dialog title="问答对编辑器" :visible.sync="QAeditorVisible" width="80%" append-to-body>
      <QAeditor
        v-if="QAeditorVisible"
        :targetDir="currentGlobalDirName"
        :workspace_slug="defaultWorkspaceSlug"
        :workspace_name="'全局文档库'"
        :tenantId="tenantId"
        :username="userInfo.username"
        :dirId="selectedGlobalDirId"
        :dirs="dirs"
        :doctitle="title"
        @submit-success="onQAeditorSuccess"
        ref="globalUploadComponent" />

    </el-dialog>        
    </div>
  </template>
  <script>
  import AnythingllmDirManage  from "@/components/AnythingllmDirManage.vue";
  import AnythingllmUploadLink from "@/components/kb_workspace/AnythingllmUploadLink.vue";
  import DocumentDowload  from "@/components/kb_workspace/DocumentDownload.vue";
  import QAeditor from "@/components/kb_workspace/QAeditor.vue";
  import AdminProgressbar from '@/components/admin/progressbar.vue'; //进度条组件
  import { listDocuments_in_folder,getDocumentStatic_by_tenant, checkDefaultFolder,deleteDocument, listBriefDirsByTenantid, query_document_details,query_richdoc_details } from '@/api/aics/KbDocument';
  import {getKbWorkspaceDocuments, EmbeddingDoc, remove_document_from_workspace, listKbWorkspaces_by_tenantId} from '@/api/aics/kbWorkspace';
//import { , createKbWorkspace, listEmployees_by_tenantId, grantKbWorkspaceToUser, getUserPermission } from '@/api/aics/kbWorkspace';  
  import AnythingllmUploadDocument  from "@/components/kb_workspace/AnythingllmUploadDocument.vue";
  import { mapState } from 'vuex';
  import EmployeeProgressbar from '@/components/employee/progress-bar.vue'; //进度条组件
  import AnythingllmRichEditor from "@/components/aics/AnythingllmRichEditor.vue";
  export default {
   name: "AdminKbDocuments",
   components: {
    AdminProgressbar,
    AnythingllmDirManage,
    AnythingllmUploadDocument,
    DocumentDowload,
    AnythingllmUploadLink,
    EmployeeProgressbar,
    AnythingllmRichEditor,
    QAeditor
   },
   props: {
    workspaceName: {
      type: String,
      default: ""
    },
    workspaceSlug: {
      type: String,
      default: ""
    },
    userType: {
        type: String,
      default: "admin"
    }
  },
   data() {
      return {
            // 分页相关数据
      pageNum: 1,
      pageSize: 10,
      total: 0,
          editDialogVisible: false,
        originalFileName: '',
        docList: [],
        workspace_docList: [],
        dirs: [],
        doc_count_tenant: 0,
        doc_storage_space: 0,
        doc_storage_space_unit: 'B',
        doc_storage_space_mb: 0, //为了比较是否超过限制
        dirId: '',
        keyword_doclibrary: '',
        keyword_workspace: '',
        doc_type_workspace: "0",
        status: 1, // 1已上传，2-已训练
        open_upload_link: false,
        loading_uploadlink: false,
        default_folder: '',
        editKey: '',

        title: '',
        open: false,
        open_details: false,
        title_setting: '',
        open_setting: false,
        title_grant: '',
        open_grant: false,
        loading: false,
        open_dir_manage: false,
        open_upload: false,
        open_download: false,
        docType: '0',

   // 图文编辑器相关
      open_editor: false,
      open_preview: false,
      editorDialogTitle: '新建图文文档',      
      currentEditDoc: null,
      editorHasContent: false,
      editorDirList: [],      
      currentPreviewDoc: null,
      submitting: false,
      defaultDirId: null, // 默认目录ID，可以从现有逻辑获取             
       // 问答对编辑器
      QAeditorVisible: false,
      selectedGlobalDirId: null,
      defaultWorkspaceSlug: '',

        form_download: {
          phone: '',
          code: '',
        },
        refreshInterval: null,
        form_dir: {
          dir: '',
        },
        form_details: {},

        // 表单校验
        rules: {
          name: [
            { required: true, message: "知识库名称不能为空", trigger: "blur" }
          ],
          serviceTo: [
            { required: true, message: "请填写知识库对应的AI客服为谁服务", trigger: "blur" }
          ],

        }
     }
   },
   computed: {
     ...mapState('auth', ['tenantInfo', 'userInfo','loginType']),

/*     tenantInfo() {
      return this.$store.getters['auth/currentTenant'];
     },*/
     tenantId() {
      return this.tenantInfo?.tenantId || null;
     },
     userName() {
      return this.userInfo?.username || null;
     },
     versionName() {
      return this.tenantInfo?.versionName || null;
     },
     maxFileCount() {
      return this.tenantInfo?.maxFileCount || 0;
     },
     maxStorageSpace() {
      return this.tenantInfo?.maxStorageSpace || 0;
     },
     kbworkspaceFolder() {
      return this.tenantInfo?.kbworkspaceFolder;
     },
         checkboxDisabled() {
      return !this.user_selected || !this.form_grant.userName;
    },
    currentGlobalDirName() {
      return this.$refs.globalLibrary?.currentDirName || '';
    },
  },
  watch: {
  // 监听父组件传入的内容
  content: {
    immediate: true,
    handler(newVal) {
      if (newVal && this.editorReady) {
        console.log("检测到新内容，设置到编辑器:", newVal.substring(0, 50));
        this.setHtml(newVal);
      }
    }
  }
  },
   mounted() {
    if(this.tenantInfo && this.tenantInfo.status && this.tenantInfo.status.trim()!=='APPROVED'){
    this.$message.error('租户状态未激活');  
    this.logout();
}  
    console.log("this.userInfo", this.userInfo);
    console.log(this.userName);
    console.log("this.workspaceSlug", this.workspaceSlug)
    console.log(this.workspaceName)
    console.log("kbworkspaceFolder:"+this.kbworkspaceFolder)
    // 当前用户的默认Anythingllm文件夹
    this.default_folder = "folder_" + this.tenantId;
    //this.form_dir.dir = this.default_folder;
 //检查默认目录是否存在,不存在则创建
    this.checkDefaultFolder();
    //this.docType ='0';
    this.default_folder= "folder_"+this.tenantId;
    // 设置定时器
    this.timerId = setInterval(() => {
      this.HandleLoadDocTable();     
      clearInterval(this.timerId);    
    }, 1000);

  },
   methods: {
      async HandleEditDocument(row) {
        console.log("HandleEditDocument", row)
        try {    
          // 获取数据
          const res = await query_richdoc_details(row.id); 
          console.log('query_richdoc_details', res)
          if (res.code === 200 && res.data) {
            const docData = res.data;
            
            // 获取文档的目录ID（可能需要从其他接口获取）
            // 暂时先设置一个默认值
            const defaultDirId = this.dirs && this.dirs.length > 0 ? this.dirs[0].id : null;
            
            const editorData = {
              id: row.id,
              title: docData.title || '',
              dirId: docData.dirId || defaultDirId, // 确保有目录ID
              description: docData.description || '',
              docAuthor: docData.docAuthor || this.userName,
              html_content: docData.html_content || '',
              htmlContent: docData.html_content || '',
              markdown_content: docData.markdown_content || '',
              markdownContent: docData.markdown_content || '',
              image_references: docData.image_references || '',
              imageReferences: docData.image_references || ''
            };
            
            console.log('传递给编辑器的数据 - dirId:', editorData.dirId);
            
            this.currentEditDoc = editorData;
              this.editorDialogTitle = editorData.title?.trim() || '新图文文档';
            this. this.QAeditorVisible = false;
            this.open_editor = true;
            this. this.QAeditorVisible = false;
            
          } else {
            this.$message.error('获取文档详情失败');
          }
        } catch (error) {
          console.error("获取文档详情失败:", error);
          this.$message.error('获取文档详情失败: ' + error.message);
        }
      },
      canNotEdit(){
        this.$message.error('不能编辑文件和网页文档，请重新上传。');
      },
      checkDefaultFolder(){
        console.log("checkDefaultFolder")
        checkDefaultFolder(this.tenantId).then(res => {
          console.log("checkDefaultFolder 完成", res);

          //if(this.kbworkspaceFolder){
            console.log("开始加载目录列表...");
            listBriefDirsByTenantid(this.tenantId).then(res => {
             this.HandleLoadDocTable();
              console.log("目录列表API返回:", res);
              console.log("原始目录数据:", res.data.data);

              this.dirs = res.data.data; 
              if(this.dirs && this.dirs.length>0){
                this.dirId = this.dirs[0].id;
              }
            }).catch(error => {
              console.error("加载目录列表失败:", error);
            });
          //}
        });
      },
    loadDefaultWorkspace() {
      listKbWorkspaces_by_tenantId(this.tenantId).then(res => {
        const workspaces = res?.data || [];
        if (workspaces.length > 0) {
          this.defaultWorkspaceSlug = workspaces[0].slug;
        }
      });
    },

      HandleUploadLink(){
          this.open_upload_link = true;
          this.loading_uploadlink = false

      },
      cancel_upload_link(){
          this.open_upload_link = false;
          this.loading_uploadlink = false;
      },
      /** 抓取网页提交按钮 */
      submitForm_upload_link: function() {
        //通过 ref 获取子组件实例并调用其 submitForm 方法
        this.loading_uploadlink= true;
        this.$refs.uploadComponent.submitForm();
    },      
    UploadLinkSucces(){
     this.open_upload_link = false;
     this.HandleLoadDocTable();
   },
   handleSelectStatus(val) {
      console.log(val);
      this.status = val;
   },
   handleSelectDir(val) {
      console.log(val);
      this.dirId = val;
   },
   handleSelectDocType(val){
      this.docType = val;
   },
   handleSelectDocTypeWorkspace(val){
     this.doc_type_workspace = val
   },
   HandleUploaddocSucess(){
    this.open_upload = false;
    this.HandleLoadDocTable();
   },
    // 新增图文文档相关方法
HandleCreateEditorDoc() {
  this.editorDialogTitle = '新图文文档';
  this.currentEditDoc = null;
  this.open_editor = true;
      this.editorHasContent = false
      
      // 初始化目录列表（这里需要调用获取目录的API）
      this.loadEditorDirectories()
    },
   // 加载编辑器目录列表
    loadEditorDirectories() {
      // 这里需要调用获取目录的API
      // 暂时使用模拟数据
      this.editorDirList = [
        { id: 1, name: '产品文档' },
        { id: 2, name: '使用指南' },
        { id: 3, name: '常见问题' }
      ]
      this.defaultDirId = 1 // 设置默认目录
    },

    HandleLoadDocTable() {
      console.log("HandleLoadDocTable")
      this.keyword_workspace = this.keyword_doclibrary;
      this.loading = true;
      if(this.dir =='')
        this.dir =0;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        dirId: this.dirId,
        docType: this.docType ==undefined?0: this.docType ,

        keyword: this.keyword_doclibrary
      };
      
      listDocuments_in_folder(this.workspaceSlug, params).then(res => {
        console.log("listDocuments_in_folder",res);
        this.refresh_workspace_doc_table();
        if(res.code === 200){
          this.docList = res.data.list || res.data;

          this.total = res.data.total || 0;
        }
        this.getDocumentStatic_by_tenant(this.tenantId);
        this.loading = false;
      });
    },
    HandleLoadWorkspaceDocTable(){
       this.refresh_workspace_doc_table();
    },
    // 编辑器内容变化
    onEditorContentChange(formData) {
      this.editorHasContent = !!(formData.htmlContent && formData.htmlContent.trim())
    },

    // 编辑器目录变化
    onEditorDirChange(dirId) {
      console.log('目录变更:', dirId)
    },    
    HandleDocDetail(row) {
      console.log("HandleDocDetail", row);
      query_document_details(row.id).then(res => {
        console.log("query_document_details", res);
        this.form_details = res.data;
        this.open_details = true;
      });
    }, 
    /**
     * 处理删除文档操作
     * @param {Object} row - 当前行的文档数据
     */
    async HandleRemove(row) {
      console.log("HandleRemove called", row);
      
      try {
        // 第一步：弹出确认对话框
        await this.$confirm(
          '是否确认从文档库和知识库中同时删除该文档？请注意，删除后AI客服在回答问题时将无法再检索该文档的内容。',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        );
        
        console.log("用户确认删除，开始调用删除API...");
        
        // 第二步：调用删除API
        const res = await deleteDocument(row.id);
        
        console.log("删除API返回结果:", res);
        
        // 第三步：根据返回结果处理
        if (res.data.data.code === 200) {
          this.$message({
            message: '删除成功',
            type: 'success',
            duration: 2000
          });
          
          // 刷新文档列表
          this.HandleLoadDocTable();
          
        } else {
          this.$message({
            message: res.message || '删除失败',
            type: 'error',
            duration: 3000
          });
        }
        
      } catch (error) {
        // 区分是用户取消还是真正的错误
        if (error === 'cancel') {
          console.log("用户取消了删除操作");
          return;
        }
        
        // 真正的错误处理
        console.error("删除过程中发生错误:", error);
        
        this.$message({
          message: error.message || '删除失败，请稍后重试',
          type: 'error',
          duration: 3000
        });
      }
    },
    HandleRemoveFromWorkspace(row){
      console.log("HandleRemoveFromWorkspace", row)
      this.$confirm(`本操作将从知识库中移除该文档，但不会影响文档库中的文档。请注意，移除后AI客服在回答问题时将无法再检索该文档的内容。是否继续？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除文档
        remove_document_from_workspace(this.tenantId,row.docpath, this.workspaceSlug).then(response => {
          console.log(response)
            try{          
            if (response.code === 200) {
              this.$message.success('删除成功');
              this.HandleLoadDocTable();
            } else {
              this.$message.error(response.data.message)
            }
          }catch(e) {
            console.log(e)
          }     
        });
      });           
    },
    HandleEmbedding(row){
      console.log(row)
      if(row)
      this.$confirm(`嵌入知识库中后，该文档将用来训练AI客服。请注意，不正确的文档会影响AI客服的表现，是否继续？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {     
        EmbeddingDoc(this.tenantId,row.id, this.workspaceSlug).then( res=>{
          console.log(res);
          if(res.data.code==200){          
            this.$message.success("嵌入成功");
            this.HandleLoadDocTable();
          }else{
                this.$message.error(res.data.message || "嵌入失败");
          }
        });
      });
    },
    HandleUploadDocument() {
      this.loading = false;
      this.open_upload = true;
    },
    HandleDownload(row) { //应急下载
        console.log("HandleDownload", row);
        this.doc_id= row.id
        this.open_download = true;
        // 应急下载，直接下载OSS上的文件
        /**get_temp_url(row.id).then(res => {
          if(res.data.code== 200){
            window.location = res.data.message;
          }
          else{
            this.$message.error(res.data.message);
          }
        })**/
    },
      closeDownloadDialog(){
        this.open_download= false;
      },
      HandleDirManage() {
        this.open_dir_manage = true;
      },
   getDocumentStatic_by_tenant(){
    getDocumentStatic_by_tenant(this.tenantId).then(res => {
      console.log("getDocumentStatic_by_tenant",res);
      this.doc_count_tenant = res.data.doc_count;
      this.doc_storage_space_mb = res.data.storage_space/1024.0/1024.0;
      console.log("doc_storage_space_mb",this.doc_storage_space_mb);
      if(res.data.storage_space<1024){
        this.doc_storage_space = res.data.storage_space;
        
        this.doc_storage_space_unit= 'B';
      }else if(res.data.storage_space<1024*1024){
        this.doc_storage_space = (res.data.storage_space/1024.0).toFixed(2);
        this.doc_storage_space_unit= 'KB';
      }else if(res.data.storage_space<1024*1024*1024){
         this.doc_storage_space = (res.data.storage_space/1024.0/1024.0).toFixed(2);
         this.doc_storage_space_unit= 'MB';
      }else{
                 this.doc_storage_space = (res.data.storage_space/1024.0/1024.0/1024.0).toFixed(2);
         this.doc_storage_space_unit= 'GB';
      }
      console.log(this.tenantId);
    });
   },
      /** 修改工作区配置提交按钮 */
      submitForm_upload: function() {
        //通过 ref 获取子组件实例并调用其 submitForm 方法
        this.$refs.uploadComponent.submitForm();
    },
    cancel_upload: function() {
        this.open_upload = false;
    },
    // 分页相关方法
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.HandleLoadDocTable();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.HandleLoadDocTable();
    },
    refresh_workspace_doc_table(){
      getKbWorkspaceDocuments(this.workspaceSlug).then(res=>{
         console.log("refresh_workspace_doc_table",res);
         if(res.code == 200){
          let arr =  new Array();
          if(this.keyword_workspace != ''){
            for(let i=0;i<res.data.length;i++){            
              console.log(i, res.data[i].title)  
              if(res.data[i].title.includes(this.keyword_workspace)){
                arr.push(res.data[i])
              }
            }            
            this.workspace_docList = arr;
          }
          else{
             this.workspace_docList = res.data;
          }
           console.log(this.workspace_docList);

         }

      });
    },
    // 解析图片引用数据
    parseImageReferences(imageRefsStr) {
      if (!imageRefsStr) {
        console.log("image_references 为空");
        return [];
      }
      
      try {
        // 如果是字符串，解析为JSON
        let imageRefs;
        if (typeof imageRefsStr === 'string') {
          console.log("解析 image_references 字符串:", imageRefsStr);
          
          // 处理可能的JSON格式问题
          let cleanedStr = imageRefsStr;
          
          // 修复常见的JSON格式问题
          cleanedStr = cleanedStr.replace(/\\/g, ''); // 移除多余的转义
          cleanedStr = cleanedStr.replace(/imageld/g, 'imageId'); // 修复字段名
          cleanedStr = cleanedStr.replace(/altText/g, 'altText'); // 确保字段名正确
          cleanedStr = cleanedStr.replace(/objectKey/g, 'objectKey'); // 确保字段名正确
          cleanedStr = cleanedStr.replace(/tempUrl/g, 'tempUrl'); // 确保字段名正确
          
          console.log("清理后的字符串:", cleanedStr);
          
          imageRefs = JSON.parse(cleanedStr);
        } else {
          // 如果是对象或数组，直接使用
          imageRefs = imageRefsStr;
        }
        
        // 确保是数组
        if (!Array.isArray(imageRefs)) {
          console.warn("image_references 不是数组:", imageRefs);
          return [];
        }
        
        // 格式化图片引用数据
        const formattedRefs = imageRefs.map((ref, index) => {
          console.log(`处理第 ${index + 1} 个图片引用:`, ref);
          
          return {
            imageId: ref.imageId || ref.imageld || 0, // 处理字段名不一致
            altText: ref.altText || '图片',
            objectKey: ref.objectKey || this.extractObjectKeyFromUrl(ref.tempUrl) || '',
            tempUrl: ref.tempUrl || this.generateTempUrl(ref.objectKey) || '',
            position: ref.position || index
          };
        });
        
        console.log("格式化后的图片引用:", formattedRefs);
        return formattedRefs;
        
      } catch (error) {
        console.error("解析 image_references 失败:", error);
        console.error("原始数据:", imageRefsStr);
        return [];
      }
    },

    // 从URL提取objectKey
    extractObjectKeyFromUrl(url) {
      if (!url) return '';
      
      try {
        // 如果是相对路径，直接返回
        if (url.includes('image-library/') && !url.includes('://')) {
          return url;
        }
        
        // 解析URL
        const urlObj = new URL(url);
        const pathname = urlObj.pathname;
        
        // 提取关键部分
        const pathParts = pathname.split('/');
        
        // 查找包含 image-library 的部分
        const imageLibIndex = pathParts.findIndex(part => part === 'image-library');
        if (imageLibIndex !== -1) {
          // 提取 image-library 之后的部分
          return pathParts.slice(imageLibIndex).join('/');
        }
        
        // 如果找不到 image-library，返回最后两部分
        return pathParts.slice(-2).join('/');
        
      } catch (error) {
        console.error("提取objectKey失败:", error, url);
        return url;
      }
    },

    // 生成临时URL（根据实际API）
    generateTempUrl(objectKey) {
      if (!objectKey) return '';
      
      // 如果已经是完整URL，直接返回
      if (objectKey.includes('://')) {
        return objectKey;
      }
      
      // 这里应该调用您的API生成临时URL
      // 暂时返回相对路径
      return objectKey;
    },    

    // 对话框完全打开后触发
    onEditDialogOpened() {
      console.log("编辑对话框已完全打开");
      console.log("当前文档内容:", this.currentEditDoc?.html_content?.substring(0, 100));
      
      // 确保编辑器组件已挂载
      this.$nextTick(() => {
        console.log("编辑器ref:", this.$refs.editor);
        
        // 如果编辑器已就绪，直接设置内容
        if (this.$refs.editor && this.isEditorReady) {
          console.log("直接设置内容到编辑器");
          this.$refs.editor.setHtml(this.currentEditDoc?.html_content || '');
        } else {
          console.log("等待编辑器就绪...");
        }
      });
    },
    
    // 编辑器就绪回调
    onEditorReady() {
      console.log("编辑器就绪回调触发");
      this.isEditorReady = true;
      
      // 编辑器就绪后设置内容
      if (this.currentEditDoc && this.currentEditDoc.html_content) {
        console.log("编辑器就绪，设置内容");
        this.$refs.editor.setHtml(this.currentEditDoc.html_content);
      }
    },
    // 打开问答对编辑器
    handleQAeditor(){

                console.log("开始加载目录列表...");
                listBriefDirsByTenantid(this.tenantId).then(res => {    
                  console.log("目录列表API返回:", res);
                  console.log("原始目录数据:", res.data.data);
                  if(res.data.code == 200){
                    this.dirs = res.data.data;
                    console.log("this.dirs", this.dirs)
                    if(this.dirs && this.dirs.length>0){
                      this.dirId = this.dirs[0].id;
                    }
                  }
                }).catch(error => {
                  console.error("加载目录列表失败:", error);
                });      
                console.log("this.dir", this.dirId);
          this.QAeditorVisible = true;
    },    
    onQAeditorSuccess() {
      this.globalUploadVisible = false;
      this.refreshGlobalLibrary();
    },    
  }
}
  </script>

  <style scoped>
  /* 主容器 */
.document-container {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 10px;
  box-sizing: border-box;
}

/* 头部区域 */
.header-section {
  width: 100%;
  margin-bottom: 20px;
}

.dashboard-tab {
  width: 100%;
  padding: 0 5px 5px 5px;
}

/* 主要内容区域 */
.main-content {
  display: flex;
  gap: 20px;
  width: 100%;
  align-items: flex-start;
  min-height: 700px;
}

/* 左右容器统一样式 */
.left-container, .right-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid #dcdfe6;
  padding: 15px;
  background: white;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  box-sizing: border-box;
  min-width: 0;
  height: 650px; /* 固定高度 */
}

/* 表格容器 */
.table-wrapper {
  flex: 1;
  min-height: 400px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}
.tab-title {
color: #333;
margin-bottom: 25px;
font-size: 1.5rem;
font-weight: 500;
margin-left: 10px;
}

  .info-text {
    color: #999;
    font-size: 0.8rem;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 20px;
    margin: 15px 20px 20px 20px ;
  }
  /* 强制覆盖弹框内所有字体（最高优先级） */
  body .el-dialog__wrapper .el-dialog .el-form-item__label,
  body .el-dialog__wrapper .el-dialog .el-input__inner {
    font-family: "PingFang SC", "Microsoft YaHei", sans-serif !important;
  }
  .agent-img{
    width: 32px;
    height: 32px;
    border-radius: 50%;
  }

  .tips-container {
    display: flex;
    justify-content: left; /* 水平居中 */
    align-items: center;    /* 垂直居中 */
    height: 70px;          /* 容器高度设为视口高度 */
  }
  .empty-img{
    display: block;
    margin: 0 auto;
    opacity: 0.45;

  }
  .empty-text{
    color: #999;
  }
  .empty-container{
    width: 100%;
    text-align: center;
  }

  /* 确保Element UI样式正确加载 */
  :deep(.el-select .el-input .el-select__caret) {
    font-family: element-icons !important;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
  }

  /* 确保图标字体正确加载 */
:deep(.el-icon-loading) {
  font-family: element-icons !important;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 加载动画样式 */
:deep(.el-icon-loading:before) {
  content: "\e6cf"; /* Element UI 加载图标的 Unicode */
  display: inline-block;
  animation: rotating 2s linear infinite;
}

@keyframes rotating {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

:deep(.left-container .el-table),
:deep(.right-container .el-table) {
  width: 100% !important;
    /* 添加固定高度和滚动 */
  max-height: 500px !important;
  overflow-y: auto !important;
}

:deep(.left-container .custom-table),
:deep(.right-container .custom-table) {
  width: 100% !important;
  margin: 5px 0 !important;
}
.container-title {
  font-family: 微软雅黑;
  font-size: 0.8rem;
  margin: 15px 0px 15px 10px;

}
.label{
  font-family: 'Courier New', Courier, monospace;
  font-size: 0.8rem;
  margin: 5px 10px 5px 10px;
}

/* 确保分页在表格下方可见 */
.left-container {
  display: flex;
  flex-direction: column;
  height: auto;
  min-height: 600px;
}

/* 表格容器 */
.left-container .el-table__body-wrapper {
  max-height: 400px;
  overflow-y: auto;
}

/* 分页样式 */
.left-container .el-pagination {
  margin-top: 15px;
  padding: 10px 0;
  background: white;
  border-top: 1px solid #ebeef5;
  position: sticky;
  bottom: 0;
  z-index: 10;
  padding: 10px 0 !important;
  margin-top: 10px !important;  
}

/* 确保整个容器有足够高度 */
.document-container {
  min-height: calc(100vh - 200px);
}

/* 主内容区域调整 */
.main-content {
  min-height: 600px;
}

/* 表格列宽调整 */
.el-table__header-wrapper th,
.el-table__body-wrapper td {
  padding: 8px 0;
}

/* 确保操作列按钮不换行 */
.el-table .cell .el-button--mini {
  margin: 2px;
  padding: 4px 8px;
  white-space: nowrap;
}

/* 表格本身 */
.table-wrapper .el-table {
  flex: 1;
  height: 100% !important;
}

/* Element UI表格的body包装器 - 设置固定高度和滚动 */
.table-wrapper .el-table .el-table__body-wrapper {
  height: calc(100% - 40px) !important; /* 减去表头高度 */
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

/* 表头固定 */
.table-wrapper .el-table .el-table__header-wrapper {
  position: sticky;
  top: 0;
  z-index: 10;
  background: white;
}
/* 分页容器 */
.pagination-wrapper {
  flex-shrink: 0;
  padding: 15px 0;
  margin-top: auto;
  text-align: center;
  background: white;
  border-top: 1px solid #ebeef5;
}
.toolbar {
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 4px;
  flex-wrap: wrap;
  gap: 10px;
}
/* 右侧表格的工具栏 */
.toolbar-right-only {
  justify-content: flex-start !important;
}

/* 确保表格内容不会溢出 */
.el-table .cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 添加滚动条样式 */
.table-wrapper .el-table__body-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.table-wrapper .el-table__body-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.table-wrapper .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.table-wrapper .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 容器标题样式 */
.container-title {
  font-family: 微软雅黑;
  font-size: 0.8rem;
  margin: 0 0 15px 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
}

/* 带图标的按钮样式 */
.btn-with-icon {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.btn-with-icon .icon {
  vertical-align: middle;
}

/* 确保操作列按钮不换行 */
.el-table .cell .el-button--mini {
  margin: 2px;
  padding: 4px 8px;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
}

/* 响应式调整 */
@media screen and (max-width: 1200px) {
  .main-content {
    flex-direction: column;
  }
  
  .left-container, .right-container {
    width: 100%;
    height: auto;
    min-height: 500px;
  }
}
.link{
  color:blue;
  text-decoration: none;
  font-size: small;
}
.link:hover{
  color: cadetblue;
}
  </style>